import ConvertQuery from "./ConvertQuery"

import {toRaw} from "vue"
import {axios as http} from "@/plugins/http"
import QuerySerializer from "@/services/QuerySerializer"

export default class Api {
    static moderate(wishId) {
        return http.post("/api/v1/wishlist/wish-moderate", {
            wish_id: wishId,
        }).then((resp) => {
            return resp.data["item"]
        })
    }

    static items(query) {
        let q = ConvertQuery.handle(toRaw(query))

        let config = {
            params: q,
            paramsSerializer: (params) => QuerySerializer.stringify(params),
        }

        return http.get("/api/v1/wishlist/wishes", config)
    }
}
